import Vue from "vue";
import Router from "vue-router";

Vue.use(Router);

/* Layout */
import Layout from "@/layout";

/**
 * Note: sub-menu only appear when route children.length >= 1
 * Detail see: https://panjiachen.github.io/vue-element-admin-site/guide/essentials/router-and-nav.html
 *
 * hidden: true                   if set true, item will not show in the sidebar(default is false)
 * alwaysShow: true               if set true, will always show the root menu
 *                                if not set alwaysShow, when item has more than one children route,
 *                                it will becomes nested mode, otherwise not show the root menu
 * redirect: noRedirect           if set noRedirect will no redirect in the breadcrumb
 * name:'router-name'             the name is used by <keep-alive> (must set!!!)
 * meta : {
    roles: ['admin','editor']    control the page roles (you can set multiple roles)
    title: 'title'               the name show in sidebar and breadcrumb (recommend set)
    icon: 'svg-name'/'el-icon-x' the icon show in the sidebar
    breadcrumb: false            if set false, the item will hidden in breadcrumb(default is true)
    activeMenu: '/example/list'  if set path, the sidebar will highlight the path you set
  }
 */

/**
 * constantRoutes
 * a base page that does not have permission requirements
 * all roles can be accessed
 */
export const constantRoutes = [
  {
    path: "/redirect",
    component: Layout,
    hidden: true,
    children: [
      {
        path: "/redirect/:path(.*)",
        component: () => import("@/views/redirect/index"),
      },
    ],
  },

  {
    path: "/login",
    component: () => import("@/views/login/login"),
    hidden: true,
  },

  {
    path: "/404",
    component: () => import("@/views/404"),
    hidden: true,
  },
];

/**
 * asyncRoutes
 * the routes that need to be dynamically loaded based on user roles
 */
export const asyncRoutes = [
  {
    path: "member",
    component: Layout,
    redirect: "memberr",
    name: "系统管理",
    meta: { title: "系统管理", icon: "el-icon-goods", roles: ["SuperAdmin", "Super", "Anchor", "Operator", "Logistics"] },
    children: [
      {
        path: "/member",
        name: "人员管理",
        component: () => import("@/views/goods/goods.member"),
        meta: {
          title: "人员管理",
          icon: "",
          noCache: true,
          affix: true,
          roles: ["SuperAdmin", "Super"],
        },
      },
      {
        path: "/member/anchor",
        name: "主播",
        component: () => import("@/views/goods/goods.anchor"),
        meta: {
          title: "主播",
          icon: "",
          noCache: true,
          affix: true,
          roles: ["SuperAdmin", "Super"],
        },
      },
      {
        path: "/member/shop",
        name: "店铺",
        component: () => import("@/views/goods/shop"),
        meta: {
          title: "店铺",
          icon: "",
          noCache: true,
          affix: true,
          roles: ["SuperAdmin", "Super"],
        },
      },
      {
        path: "/member/operator",
        name: "运营排班",
        component: () => import("@/views/goods/operator"),
        meta: {
          title: "运营排班",
          icon: "",
          noCache: true,
          affix: true,
          roles: ["SuperAdmin", "Super"],
        },
      },
      {
        path: "/goods/sale/profit",
        name: "货品成本配置",
        component: () => import("@/views/goods/sale.profit"),
        meta: {
          title: "货品成本配置",
          icon: "",
          noCache: true,
          affix: true,
          roles: ["SuperAdmin", "Super"],
        },
      },
      {
        path: "/goods/ad/cost",
        name: "广告成本配置",
        component: () => import("@/views/goods/goods.ad.cost"),
        meta: {
          title: "广告成本配置",
          icon: "",
          noCache: true,
          affix: true,
          roles: ["SuperAdmin", "Super"],
        },
      },
      {
        path: "/goods/sale/saleProfitDay/day",
        name: "销售利润分析",
        component: () => import("@/views/goods/saleProfitDay.day"),
        meta: {
          title: "销售利润分析",
          icon: "",
          noCache: true,
          affix: true,
          roles: ["SuperAdmin", "Super"],
        },
      },
      {
        path: "/purchase/activity",
        name: "活动管理",
        component: () => import("@/views/goods/activity"),
        meta: {
          title: "活动管理",
          icon: "",
          noCache: true,
          affix: true,
          roles: ["Anchor", "Operator"],
        },
      },
      {
        path: "/goods/sale/performance",
        name: "主播绩效激励核算",
        component: () => import("@/views/goods/sale.performance"),
        meta: {
          title: "主播绩效激励核算",
          icon: "",
          noCache: true,
          affix: true,
          roles: ["SuperAdmin", "Super", "Keeper", "Anchor"],
        },
      },
      {
        path: "/goods/sale/monthPerformance",
        name: "运营绩效激励核算",
        component: () => import("@/views/goods/sale.monthPerformance"),
        meta: {
          title: "运营绩效激励核算",
          icon: "",
          noCache: true,
          affix: true,
          roles: ["SuperAdmin", "Super", "Keeper", "Operator"],
        },
      },
      {
        path: "/purchase/goodsPlay",
        name: "商品玩法",
        component: () => import("@/views/goods/goodsPlay"),
        meta: {
          title: "商品玩法",
          icon: "",
          noCache: true,
          affix: true,
          roles: ["Keeper", "Operator"],
        },
      },
      {
        path: "/goods/sale/financial/statement",
        name: "财务报账表-代拆",
        component: () => import("@/views/goods/financialStatement.detail"),
        meta: {
          title: "财务报账表-代拆",
          icon: "",
          noCache: true,
          affix: true,
          roles: ["SuperAdmin", "Super", "Logistics"],
        },
      },
      {
        path: "/goods/sale/financial/statement1",
        name: "财务报账表-直发",
        component: () => import("@/views/goods/financialStatement.detail1"),
        meta: {
          title: "财务报账表-直发",
          icon: "",
          noCache: true,
          affix: true,
          roles: ["SuperAdmin", "Super", "Logistics"],
        },
      },
      {
        path: "/goods/saleForChuang",
        name: "业绩核算-折扣率版本",
        component: () => import("@/views/goods/saleForChuang.day.vue"),
        meta: {
          title: "业绩核算-折扣率版本",
          icon: "",
          noCache: true,
          affix: true,
          roles: ["SuperAdmin", "Super"],
        },
      },
      {
        path: "/goods/depreciation",
        name: "定向拿货折旧损失表",
        component: () => import("@/views/goods/depreciation"),
        meta: {
          title: "定向拿货折旧损失表",
          icon: "",
          noCache: true,
          affix: true,
          roles: ["SuperAdmin"],
        },
      },
      {
        path: "/goods/profit",
        name: "定向拿货库存收益",
        component: () => import("@/views/goods/profit"),
        meta: {
          title: "定向拿货库存收益",
          icon: "",
          noCache: true,
          affix: true,
          roles: ["SuperAdmin"],
        },
      },
    ],
  },
  {
    path: "distribution",
    component: Layout,
    redirect: "distribution",
    name: "经销管理",
    meta: { title: "经销管理", icon: "el-icon-goods", roles: ["SuperAdmin", "Super", "Distribution", "Logistics"] },
    children: [
      {
        path: "/distribution/distribution",
        name: "经销销售",
        component: () => import("@/views/goods/distribution"),
        meta: {
          title: "经销销售",
          icon: "",
          noCache: true,
          affix: true,
          roles: ["SuperAdmin", "Super", "Distribution", "Logistics"],
        },
      },
      {
        path: "/distribution/distributionStockOut",
        name: "经销销售出库",
        component: () => import("@/views/goods/distributionStockOut"),
        meta: {
          title: "经销销售出库",
          icon: "",
          noCache: true,
          affix: true,
          roles: ["SuperAdmin", "Super", "Distribution", "Logistics"],
        },
      },
      {
        path: "/distribution/distributionReturn",
        name: "经销销售退货",
        component: () => import("@/views/goods/distributionReturn"),
        meta: {
          title: "经销销售退货",
          icon: "",
          noCache: true,
          affix: true,
          roles: ["SuperAdmin", "Super", "Distribution", "Logistics"],
        },
      },
      {
        path: "/distribution/distributionProfit",
        name: "经销货品成本配置",
        component: () => import("@/views/goods/distributionProfit"),
        meta: {
          title: "经销货品成本配置",
          icon: "",
          noCache: true,
          affix: true,
          roles: ["SuperAdmin", "Super", "Distribution", "Logistics"],
        },
      },
      {
        path: "/distribution/channel",
        name: "渠道",
        component: () => import("@/views/goods/goods.channel"),
        meta: {
          title: "渠道",
          icon: "",
          noCache: true,
          affix: true,
          roles: ["SuperAdmin", "Super", "Logistics"],
        },
      },
    ],
  },
  {
    path: "purchase",
    component: Layout,
    redirect: "purchase",
    name: "采购管理",
    meta: { title: "采购管理", icon: "el-icon-goods", roles: ["SuperAdmin", "Super", "Buyer", "Logistics"] },
    children: [
      {
        path: "/purchase/supplier",
        name: "供应商",
        component: () => import("@/views/goods/goods.supplier"),
        meta: {
          title: "供应商",
          icon: "",
          noCache: true,
          affix: true,
          roles: ["SuperAdmin", "Super", "Buyer", "Logistics"],
        },
      },
      {
        path: "/purchase/goods",
        name: "商品明细表",
        component: () => import("@/views/goods/index"),
        meta: {
          title: "商品明细表",
          icon: "",
          noCache: true,
          affix: true,
          roles: ["SuperAdmin", "Super", "Buyer", "Logistics"],
        },
      },
      {
        path: "/purchase/order",
        name: "订货明细表",
        component: () => import("@/views/goods/goods.order"),
        meta: {
          title: "订货明细表",
          icon: "",
          noCache: true,
          affix: true,
          roles: ["SuperAdmin", "Super", "Buyer", "Logistics"],
        },
      },
      {
        path: "/purchase/order/return",
        name: "退单明细表",
        component: () => import("@/views/goods/goods.order.return"),
        meta: {
          title: "退单明细表",
          icon: "",
          noCache: true,
          affix: true,
          roles: ["SuperAdmin", "Super", "Buyer", "Logistics"],
        },
      },
    ],
  },
  {
    path: "gift",
    component: Layout,
    redirect: "gift",
    name: "礼品管理",
    meta: { title: "礼品管理", icon: "el-icon-goods", roles: ["SuperAdmin", "Super", "Buyer"] },
    children: [
      {
        path: "/purchase/gift",
        name: "礼品明细表",
        component: () => import("@/views/goods/gift"),
        meta: {
          title: "礼品明细表",
          icon: "",
          noCache: true,
          affix: true,
          roles: ["SuperAdmin", "Super", "Buyer"],
        },
      },
      {
        path: "/gift/inventory",
        name: "礼品库存表",
        component: () => import("@/views/goods/gift.inventory"),
        meta: {
          title: "礼品库存表",
          icon: "",
          noCache: true,
          affix: true,
          roles: ["SuperAdmin", "Super", "Buyer"],
        },
      },
      {
        path: "/gift/warehous",
        name: "礼品入库表",
        component: () => import("@/views/goods/gift.warehous"),
        meta: {
          title: "礼品入库表",
          icon: "",
          noCache: true,
          affix: true,
          roles: ["SuperAdmin", "Super", "Buyer"],
        },
      },
      {
        path: "/gift/requisition/audit",
        name: "礼品申领审核",
        component: () => import("@/views/goods/gift.requisition.audit"),
        meta: {
          title: "礼品申领审核",
          icon: "",
          noCache: true,
          affix: true,
          roles: ["SuperAdmin", "Super", "Buyer"],
        },
      },
    ],
  },
  {
    path: "operation",
    component: Layout,
    redirect: "operation",
    name: "运营管理",
    meta: { title: "运营管理", icon: "el-icon-goods", roles: ["SuperAdmin", "Super", "Keeper", "Anchor", "Operator", "External"] },
    children: [
      {
        path: "/goods/sale",
        name: "每日销售总表",
        component: () => import("@/views/goods/sale.day"),
        meta: {
          title: "每日销售总表",
          icon: "",
          noCache: true,
          affix: true,
          roles: ["SuperAdmin", "Super", "Keeper", "Anchor", "Operator"],
        },
      },
      {
        path: "/goods/sale/detail",
        name: "每日销售明细表",
        component: () => import("@/views/goods/sale.day.detail"),
        meta: {
          title: "每日销售明细表",
          icon: "",
          noCache: true,
          affix: true,
          roles: ["SuperAdmin", "Super", "Keeper"],
        },
      },
      {
        path: "/goods/sale/group",
        name: "商品销售总表",
        component: () => import("@/views/goods/group"),
        meta: {
          title: "商品销售总表",
          icon: "",
          noCache: true,
          affix: true,
          roles: ["SuperAdmin", "Super", "Keeper"],
        },
      },
      {
        path: "/goods/sale/remittance",
        name: "欠款明细表",
        component: () => import("@/views/goods/sale.remittance"),
        meta: {
          title: "欠款明细表",
          icon: "",
          noCache: true,
          affix: true,
          // roles: ["SuperAdmin" ,"Super", "Keeper"],
          roles: [],
        },
      },
      {
        path: "/purchase/goods",
        name: "商品明细表",
        component: () => import("@/views/goods/index"),
        meta: {
          title: "商品明细表",
          icon: "",
          noCache: true,
          affix: true,
          roles: ["SuperAdmin", "Super", "Keeper"],
        },
      },
      {
        path: "/goods/sale/gameplay",
        name: "玩法定价-卡位停",
        component: () => import("@/views/goods/gameplay"),
        meta: {
          title: "玩法定价-卡位停",
          icon: "",
          noCache: true,
          affix: true,
          roles: ["SuperAdmin", "Super", "Operator", "External"],
        },
      },
      {
        path: "/goods/sale/gameplayAdd",
        name: "玩法定价-卡位加",
        component: () => import("@/views/goods/gameplayAdd"),
        meta: {
          title: "玩法定价-卡位加",
          icon: "",
          noCache: true,
          affix: true,
          roles: ["SuperAdmin", "Super", "Operator", "External"],
        },
      },
      {
        path: "/goods/sale/gameplayBag",
        name: "玩法定价-单包刺盒",
        component: () => import("@/views/goods/gameplayBag"),
        meta: {
          title: "玩法定价-单包刺盒",
          icon: "",
          noCache: true,
          affix: true,
          roles: ["SuperAdmin", "Super", "Operator", "External"],
        },
      },
      {
        path: "/goods/sale/gameplayPK",
        name: "玩法定价-主播与客户 PK",
        component: () => import("@/views/goods/gameplayPK"),
        meta: {
          title: "玩法定价-主播与客户 PK",
          icon: "",
          noCache: true,
          affix: true,
          roles: ["SuperAdmin", "Super", "Operator", "External"],
        },
      },
      {
        path: "/goods/sale/gameplayPenPen",
        name: "玩法定价-碰碰玩法",
        component: () => import("@/views/goods/gameplayPenPen"),
        meta: {
          title: "玩法定价-碰碰玩法",
          icon: "",
          noCache: true,
          affix: true,
          roles: ["SuperAdmin", "Super", "Operator", "External"],
        },
      },
    ],
  },
  {
    path: "inventory",
    component: Layout,
    redirect: "inventory",
    name: "库存管理",
    meta: { title: "库存管理", icon: "el-icon-goods", roles: ["SuperAdmin", "Super", "Buyer", "Anchor", "Operator", "Distribution", "Inventory", "Logistics"] },
    children: [
      {
        path: "/goods/inventory/warehous/wait",
        name: "待入库明细表",
        component: () => import("@/views/goods/goods.wait.order"),
        meta: {
          title: "待入库明细表",
          icon: "",
          noCache: true,
          affix: true,
          roles: ["SuperAdmin", "Super", "Buyer", "Logistics"],
        },
      },
      {
        path: "/goods/inventory/warehous",
        name: "入库明细表",
        component: () => import("@/views/goods/goods.warehous"),
        meta: {
          title: "入库明细表",
          icon: "",
          noCache: true,
          affix: true,
          roles: ["SuperAdmin", "Super", "Buyer", "Logistics"],
        },
      },
      {
        path: "/goods/inventory/return",
        name: "退货明细表",
        component: () => import("@/views/goods/goods.return"),
        meta: {
          title: "退货明细表",
          icon: "",
          noCache: true,
          affix: true,
          roles: ["SuperAdmin", "Super", "Buyer", "Anchor", "Operator", "Logistics"],
        },
      },
      {
        path: "/sale/anchor/goods/requisition",
        name: "货品领取明细表",
        component: () => import("@/views/goods/goods.requisition"),
        meta: {
          title: "货品领取明细表",
          icon: "",
          noCache: true,
          affix: true,
          roles: ["Anchor", "Operator"],
        },
      },
      {
        path: "/goods/requisition/audit/anchor",
        name: "货品调拨审核",
        component: () => import("@/views/goods/goods.requisition.anchor"),
        meta: {
          title: "货品调拨审核",
          icon: "",
          noCache: true,
          affix: true,
          roles: ["Anchor", "Operator"],
        },
      },
      {
        path: "/sale/anchor/gift/requisition",
        name: "礼品领取明细表",
        component: () => import("@/views/goods/gift.requisition"),
        meta: {
          title: "礼品领取明细表",
          icon: "",
          noCache: true,
          affix: true,
          roles: ["Anchor", "Operator"],
        },
      },
      {
        path: "/gift/requisition/audit/anchor",
        name: "礼品调拨审核",
        component: () => import("@/views/goods/gift.requisition.anchor"),
        meta: {
          title: "礼品调拨审核",
          icon: "",
          noCache: true,
          affix: true,
          roles: ["Anchor", "Operator"],
        },
      },
      {
        path: "/goods/inventory/exchange",
        name: "整盒换散包",
        component: () => import("@/views/goods/goods.exchange"),
        meta: {
          title: "整盒换散包",
          icon: "",
          noCache: true,
          affix: true,
          roles: ["Anchor", "Operator"],
        },
      },
      {
        path: "/goods/inventory/exchange",
        name: "整盒换散包",
        component: () => import("@/views/goods/goods.exchange"),
        meta: {
          title: "整盒换散包",
          icon: "",
          noCache: true,
          affix: true,
          roles: ["SuperAdmin", "Super", "Buyer", "Logistics"],
        },
      },
      {
        path: "/goods/requisition/audit",
        name: "货品领取审核",
        component: () => import("@/views/goods/goods.requisition.audit"),
        meta: {
          title: "货品领取审核",
          icon: "",
          noCache: true,
          affix: true,
          roles: ["SuperAdmin", "Super", "Buyer", "Logistics"],
        },
      },
      {
        path: "/gift/requisition/audit",
        name: "礼品领取审核",
        component: () => import("@/views/goods/gift.requisition.audit"),
        meta: {
          title: "礼品领取审核",
          icon: "",
          noCache: true,
          affix: true,
          roles: ["SuperAdmin", "Super", "Buyer", "Logistics"],
        },
      },
      {
        path: "/sale/inventoryTask",
        name: "盘点任务",
        component: () => import("@/views/goods/inventoryTask"),
        meta: {
          title: "盘点任务",
          icon: "",
          noCache: true,
          affix: true,
          roles: ["SuperAdmin", "Super", "Buyer", "Logistics"],
        },
      },
      {
        path: "/stash/monthInventory",
        name: "月盘点分析",
        component: () => import("@/views/goods/monthInventory"),
        meta: {
          title: "月盘点分析",
          icon: "",
          noCache: true,
          affix: true,
          roles: ["SuperAdmin", "Super", "Logistics"],
        },
      },
      {
        path: "/sale/inventory",
        name: "销售盘点",
        component: () => import("@/views/goods/inventory"),
        meta: {
          title: "销售盘点",
          icon: "",
          noCache: true,
          affix: true,
          roles: ["SuperAdmin", "Super", "Buyer", "Anchor", "Operator", "Logistics"],
        },
      },
      {
        path: "/stash/inventory",
        name: "仓库盘点",
        component: () => import("@/views/goods/stashInventory"),
        meta: {
          title: "仓库盘点",
          icon: "",
          noCache: true,
          affix: true,
          roles: ["SuperAdmin", "Super", "Buyer", "Inventory", "Logistics"],
        },
      },
      {
        path: "/inventory/inventory",
        name: "库存查询",
        component: () => import("@/views/goods/inventoryInventory"),
        meta: {
          title: "库存查询",
          icon: "",
          noCache: true,
          affix: true,
          roles: ["SuperAdmin", "Super", "Anchor", "Operator", "Distribution", "Logistics"],
        },
      },
      {
        path: "/goods/inventory/scheduling",
        name: "仓库调拨",
        component: () => import("@/views/goods/goods.scheduling"),
        meta: {
          title: "仓库调拨",
          icon: "",
          noCache: true,
          affix: true,
          roles: ["SuperAdmin", "Super", "Operator", "Distribution", "Logistics"],
        },
      },
      {
        path: "/goods/return/factory",
        name: "退回厂家",
        component: () => import("@/views/goods/goods.returnFactory"),
        meta: {
          title: "退回厂家",
          icon: "",
          noCache: true,
          affix: true,
          roles: ["SuperAdmin", "Super", "Operator", "Distribution", "Logistics"],
        },
      },
    ],
  },
  {
    path: "sale",
    component: Layout,
    redirect: "sale",
    name: "销售管理",
    meta: { title: "销售管理", icon: "el-icon-goods", roles: ["Anchor", "Operator"] },
    children: [
      {
        path: "/sale/anchor",
        name: "直播间销售表",
        component: () => import("@/views/goods/sale.anchor"),
        meta: {
          title: "直播间销售表",
          icon: "",
          noCache: true,
          affix: true,
          roles: ["Anchor", "Operator"],
        },
      },
      {
        path: "/goods/ad/cost",
        name: "广告成本配置",
        component: () => import("@/views/goods/goods.ad.cost"),
        meta: {
          title: "广告成本配置",
          icon: "",
          noCache: true,
          affix: true,
          roles: ["Anchor", "Operator"],
        },
      },
      {
        path: "/purchase/goods",
        name: "商品明细表",
        component: () => import("@/views/goods/index"),
        meta: {
          title: "商品明细表",
          icon: "",
          noCache: true,
          affix: true,
          roles: ["Operator"],
        },
      },
    ],
  },

  // 404 page must be placed at the end !!!
  { path: "*", redirect: "/404", hidden: true },
];

const createRouter = () =>
  new Router({
    // mode: 'history', // require service support
    scrollBehavior: () => ({ y: 0 }),
    routes: constantRoutes,
  });

const router = createRouter();

// Detail see: https://github.com/vuejs/vue-router/issues/1234#issuecomment-357941465
export function resetRouter() {
  const newRouter = createRouter();
  router.matcher = newRouter.matcher; // reset router
}

export default router;
